"use strict";

import { settingConstants } from "../_constants";

export const settingSetAuthForm = (payload) => {
  return {
    type: settingConstants.SETTING_SHOW_AUTH_FORM,
    payload,
  };
};

export const settingSetUnAuthenticated = () => {
  return {
    type: settingConstants.SETTING_SET_UNAUTHENTICATED,
  };
};

export const settingChangePasswordRequest = (payload) => {
  return {
    type: settingConstants.SETTING_CHANGE_PASSWORD_REQUEST,
    payload,
  };
};

export const settingChangePasswordComplete = (payload) => {
  return {
    type: settingConstants.SETTING_CHANGE_PASSWORD_COMPLETE,
    payload,
  };
};

export const settingChangePasscodeRequest = (payload) => {
  return {
    type: settingConstants.SETTING_CHANGE_PASSCODE_REQUEST,
    payload,
  };
};

export const settingChangePasscodeError = (payload) => {
  return {
    type: settingConstants.SETTING_CHANGE_PASSCODE_ERROR,
    payload,
  };
};

export const settingChangePasscodeComplete = (payload) => {
  return {
    type: settingConstants.SETTING_CHANGE_PASSCODE_COMPLETE,
    payload,
  };
};

export const settingChangePasscodeOtpConfirmRequest = (payload) => {
  return {
    type: settingConstants.SETTING_CHANGE_PASSCODE_OTP_CONFIRM_REQUEST,
    payload,
  };
};

export const settingChangePasscodeOtpConfirmComplete = (payload) => {
  return {
    type: settingConstants.SETTING_CHANGE_PASSCODE_OTP_CONFIRM_COMPLETE,
    payload,
  };
};

export const settingChangePasscodeOtpConfirmError = (payload) => {
  return {
    type: settingConstants.SETTING_CHANGE_PASSCODE_OTP_CONFIRM_ERROR,
    payload,
  };
};

export const onCloseSettingChangePasscodeOtpConfirmRetry = () => {
  return {
    type: settingConstants.ON_CLOSE_SETTING_CHANGE_PASSCODE_OTP_CONFIRM_RETRY,
  };
};

export const settingChangePasscodeOtpResendRequest = (payload) => {
  return {
    type: settingConstants.SETTING_CHANGE_PASSCODE_OTP_RESEND_REQUEST,
    payload,
  };
};

export const settingChangePasscodeOtpResendComplete = (payload) => {
  return {
    type: settingConstants.SETTING_CHANGE_PASSCODE_OTP_RESEND_COMPLETE,
    payload,
  };
};

export const settingChangePasscodeOtpResendError = (payload) => {
  return {
    type: settingConstants.SETTING_CHANGE_PASSCODE_OTP_RESEND_ERROR,
    payload,
  };
};

export const settingAuthenticateRequest = (payload) => {
  return {
    type: settingConstants.SETTING_AUTHENTICATE_REQUEST,
    payload,
  };
};

export const settingAuthenticateComplete = (payload) => {
  return {
    type: settingConstants.SETTING_AUTHENTICATE_COMPLETE,
    payload,
  };
};

export const settingAuthenticateError = () => {
  return {
    type: settingConstants.SETTING_AUTHENTICATE_ERROR,
  };
};

export const settingChangePasscodeValidateRequest = (payload) => {
  return {
    type: settingConstants.SETTING_CHANGE_PASSCODE_VALIDATE_REQUEST,
    payload,
  };
};

export const settingChangePasscodeValidateComplete = (payload) => {
  return {
    type: settingConstants.SETTING_CHANGE_PASSCODE_VALIDATE_COMPLETE,
    payload,
  };
};

export const settingChangePasscodeValidateError = () => {
  return {
    type: settingConstants.SETTING_CHANGE_PASSCODE_VALIDATE_ERROR,
  };
};

// --------account preferences actions--------
export const settingGetAllAccountsRequest = (payload) => {
  return {
    type: settingConstants.SETTING_GET_ALL_ACCOUNTS_REQUEST,
    payload,
  };
};

export const settingGetAllAccountsComplete = (payload) => {
  return {
    type: settingConstants.SETTING_GET_ALL_ACCOUNTS_COMPLETE,
    payload,
  };
};

export const settingGetAllAccountsError = (payload) => {
  return {
    type: settingConstants.SETTING_GET_ALL_ACCOUNTS_ERROR,
    payload,
  };
};

export const settingGetAllNotificationCategoryRequest = () => {
  return {
    type: settingConstants.SETTING_GET_ALL_NOTIFICATION_CATEGORY_REQUEST,
  };
};

export const settingGetAllNotificationCategoryComplete = (payload) => {
  return {
    type: settingConstants.SETTING_GET_ALL_NOTIFICATION_CATEGORY_COMPLETE,
    payload,
  };
};

export const settingUpdateNotificationCategoryRequest = (payload) => {
  return {
    type: settingConstants.SETTING_UPDATE_NOTIFICATION_CATEGORY_REQUEST,
    payload,
  };
};

export const settingUpdateNotificationCategoryComplete = (payload) => {
  return {
    type: settingConstants.SETTING_UPDATE_NOTIFICATION_CATEGORY_COMPLETE,
    payload,
  };
};

export const settingGetSelectedAccountsRequest = (payload) => {
  return {
    type: settingConstants.SETTING_GET_SELECTED_ACCOUNTS_REQUEST,
    payload,
  };
};

export const settingGetSelectedAccountsComplete = (payload) => {
  return {
    type: settingConstants.SETTING_GET_SELECTED_ACCOUNTS_COMPLETE,
    payload,
  };
};

export const settingChangeOperatingTypeRequest = (payload) => {
  return {
    type: settingConstants.SETTING_CHANGE_OPERATING_TYPE_REQUEST,
    payload,
  };
};

export const settingChangeOperatingTypeComplete = (payload) => {
  return {
    type: settingConstants.SETTING_CHANGE_OPERATING_TYPE_COMPLETE,
    payload,
  };
};

export const settingChangeOperatingTypeError = (payload) => {
  return {
    type: settingConstants.SETTING_CHANGE_OPERATING_TYPE_ERROR,
    payload,
  };
};

// --------credit card preferences actions--------
export const settingGetAllCreditCardPrefRequest = (payload) => {
  return {
    type: settingConstants.SETTING_GET_ALL_CREDIT_CARD_PREF_REQUEST,
    payload,
  };
};

export const settingGetAllCreditCardPrefComplete = (payload) => {
  return {
    type: settingConstants.SETTING_GET_ALL_CREDIT_CARD_PREF_COMPLETE,
    payload,
  };
};
export const settingGetAllCreditCardPrefError = (payload) => {
  return {
    type: settingConstants.SETTING_GET_ALL_CREDIT_CARD_PREF_ERROR,
    payload,
  };
};

export const settingChangeCreditCardOperatingTypeRequest = (payload) => {
  return {
    type: settingConstants.SETTING_CHANGE_CREDIT_CARD_OPERATING_TYPE_REQUEST,
    payload,
  };
};

export const settingChangeCreditCardOperatingTypeComplete = (payload) => {
  return {
    type: settingConstants.SETTING_CHANGE_CREDIT_CARD_OPERATING_TYPE_COMPLETE,
    payload,
  };
};

export const settingChangeCreditCardOperatingTypeError = (payload) => {
  return {
    type: settingConstants.SETTING_CHANGE_CREDIT_CARD_OPERATING_TYPE_ERROR,
    payload,
  };
};

export const settingRemoveCreditCardRequest = (payload) => {
  return {
    type: settingConstants.SETTING_REMOVE_CREDIT_CARD_REQUEST,
    payload,
  };
};

export const settingRemoveCreditCardComplete = (payload) => {
  return {
    type: settingConstants.SETTING_REMOVE_CREDIT_CARD_COMPLETE,
    payload,
  };
};

export const settingGetCustomerProfileRequest = (payload) => {
  return {
    type: settingConstants.SETTING_GET_CUSTOMER_PROFILE_DATA_REQUEST,
    payload,
  };
};

export const settingGetCustomerProfileComplete = (payload) => {
  return {
    type: settingConstants.SETTING_GET_CUSTOMER_PROFILE_DATA_COMPLETE,
    payload,
  };
};

//transfer limit actions

export const settingsTransferLimitScreenType = (payload) => {
  return {
    type: settingConstants.TRANSFER_LIMITS_SET_SCREEN_TYPE,
    payload,
  };
};

export const settingsTransferType = (payload) => {
  return {
    type: settingConstants.SELECTED_TRANSFER_TYPE,
    payload,
  };
};

export const settingGetTransferLimitsRequest = (payload) => {
  return {
    type: settingConstants.SETTING_GET_TRANSFER_LIMITS_REQUEST,
    payload,
  };
};

export const settingGetTransferLimitsComplete = (payload) => {
  return {
    type: settingConstants.SETTING_GET_TRANSFER_LIMITS_COMPLETE,
    payload,
  };
};

export const settingGetTransferLimitsError = (payload) => {
  return {
    type: settingConstants.SETTING_GET_TRANSFER_LIMITS_ERROR,
    payload,
  };
};

export const settingAddTransferLimitRequest = (payload) => {
  return {
    type: settingConstants.SETTING_ADD_TRANSFER_LIMIT_REQUEST,
    payload,
  };
};

export const settingAddTransferLimitComplete = (payload) => {
  return {
    type: settingConstants.SETTING_ADD_TRANSFER_LIMIT_COMPLETE,
    payload,
  };
};

export const settingAddTransferLimitError = (payload) => {
  return {
    type: settingConstants.SETTING_ADD_TRANSFER_LIMIT_ERROR,
    payload,
  };
};

export const resetTransferLimitSetting = () => {
  return {
    type: settingConstants.RESET_TRANSFER_LIMIT_SETTING,
  };
};

export const settingSetInitial = () => {
  return {
    type: settingConstants.SETTING_SET_INITIAL,
  };
};

export const settingGetAllSavingAccountsRequest = (payload) => {
  return {
    type: settingConstants.SETTING_GET_ALL_SAVING_ACCOUNTS_REQUEST,
    payload,
  };
};

export const settingGetAllSavingAccountsComplete = (payload) => {
  return {
    type: settingConstants.SETTING_GET_ALL_SAVING_ACCOUNTS_COMPLETE,
    payload,
  };
};

export const settingGetAllSavingAccountsError = (payload) => {
  return {
    type: settingConstants.SETTING_GET_ALL_SAVING_ACCOUNTS_ERROR,
    payload,
  };
};

export const updateDefaultAccountRequest = (payload) => {
  return {
    type: settingConstants.UPDATE_DEFAULT_ACCOUNT_REQUEST,
    payload,
  };
};

export const updateDefaultAccountComplete = (payload) => {
  return {
    type: settingConstants.UPDATE_DEFAULT_ACCOUNT_COMPLETE,
    payload,
  };
};

export const updateDefaultAccountError = (payload) => {
  return {
    type: settingConstants.UPDATE_DEFAULT_ACCOUNT_ERROR,
    payload,
  };
};
export const resetDefaultAccountSetting = () => {
  return {
    type: settingConstants.RESET_DEFAULT_ACCOUNT_SETTING,
  };
};

export const setAccountNicknameRequest = (payload) => {
  return {
    type: settingConstants.SET_ACCOUNT_NICKNAME_REQUEST,
    payload,
  };
};

export const setAccountNicknameComplete = (payload) => {
  return {
    type: settingConstants.SET_ACCOUNT_NICKNAME_COMPLETE,
    payload,
  };
};

export const setAccountNicknameError = (payload) => {
  return {
    type: settingConstants.SET_ACCOUNT_NICKNAME_ERROR,
    payload,
  };
};

export const setAccountNicknameClearState = () => {
  return {
    type: settingConstants.SET_ACCOUNT_NICKNAME_CLEAR_ALL,
  };
};

export const settingOtpPrefGetTwofaMethodRequest = (payload) => {
  return {
    type: settingConstants.SETTING_OTP_PREF_GET_TWOFA_METHOD_REQUEST,
    payload,
  };
};

export const settingOtpPrefGetTwofaMethodComplete = (payload) => {
  return {
    type: settingConstants.SETTING_OTP_PREF_GET_TWOFA_METHOD_COMPLETE,
    payload,
  };
};

export const settingOtpPrefGetTwofaMethodError = (payload) => {
  return {
    type: settingConstants.SETTING_OTP_PREF_GET_TWOFA_METHOD_ERROR,
    payload,
  };
};

export const settingOtpPrefGetTwofaRequestOtpRequest = (payload) => {
  return {
    type: settingConstants.SETTING_OTP_PREF_GET_TWOFA_SEND_OTP_REQUEST,
    payload,
  };
};

export const settingOtpPrefGetTwofaRequestOtpComplete = (payload) => {
  return {
    type: settingConstants.SETTING_OTP_PREF_GET_TWOFA_SEND_OTP_COMPLETE,
    payload,
  };
};

export const settingOtpPrefGetTwofaRequestOtpError = (payload) => {
  return {
    type: settingConstants.SETTING_OTP_PREF_GET_TWOFA_SEND_OTP_ERROR,
    payload,
  };
};

export const settingOtpPrefGetTwofaResendOtpRequest = (payload) => {
  return {
    type: settingConstants.SETTING_OTP_PREF_GET_TWOFA_RESEND_OTP_REQUEST,
    payload,
  };
};

export const settingOtpPrefGetTwofaResendOtpComplete = (payload) => {
  return {
    type: settingConstants.SETTING_OTP_PREF_GET_TWOFA_RESEND_OTP_COMPLETE,
    payload,
  };
};

export const settingOtpPrefGetTwofaResendOtpError = (payload) => {
  return {
    type: settingConstants.SETTING_OTP_PREF_GET_TWOFA_RESEND_OTP_ERROR,
    payload,
  };
};

export const settingOtpPrefGetTwofaConfirmOtpRequest = (payload) => {
  return {
    type: settingConstants.SETTING_OTP_PREF_GET_TWOFA_CONFORM_OTP_REQUEST,
    payload,
  };
};

export const settingOtpPrefGetTwofaConfirmOtpComplete = (payload) => {
  return {
    type: settingConstants.SETTING_OTP_PREF_GET_TWOFA_CONFORM_OTP_COMPLETE,
    payload,
  };
};

export const settingOtpPrefGetTwofaConfirmOtpError = (payload) => {
  return {
    type: settingConstants.SETTING_OTP_PREF_GET_TWOFA_CONFORM_OTP_ERROR,
    payload,
  };
};

export const OnExitSettingOtpPrefGetTwofaConfirmOtpRetry = (payload) => {
  return {
    type: settingConstants.ON_EXIT_SETTING_OTP_PREF_GET_TWOFA_CONFORM_OTP_RETRY,
    payload,
  };
};

export const currentChangePasswordScreenType = (screenType) => ({
  type: settingConstants.CHANGE_PASSWORD_SET_SCREEN_TYPE,
  payload: screenType,
});

export const clearTransferLimits = (payload) => ({
  type: settingConstants.CLEAR_TRANSFER_LIMITS,
  payload,
});

export const settingGetNotificationCategoriesRequest = (payload) => {
  return {
    type: settingConstants.SETTING_GET_NOTIFICATION_CATEGORIES_REQUEST,
    payload,
  };
};

export const settingGetNotificationCategoriesComplete = (payload) => {
  return {
    type: settingConstants.SETTING_GET_NOTIFICATION_CATEGORIES_COMPLETE,
    payload,
  };
};

export const settingGetNotificationCategoriesError = (payload) => {
  return {
    type: settingConstants.SETTING_GET_NOTIFICATION_CATEGORIES_ERROR,
    payload,
  };
};

export const updateNotificationCategoryRequest = (payload) => {
  return {
    type: settingConstants.UPDATE_NOTIFICATION_CATEGORY_REQUEST,
    payload,
  };
};

export const updateNotificationCategoryComplete = (payload) => {
  return {
    type: settingConstants.UPDATE_NOTIFICATION_CATEGORY_COMPLETE,
    payload,
  };
};

export const updateNotificationCategoryError = (payload) => {
  return {
    type: settingConstants.UPDATE_NOTIFICATION_CATEGORY_ERROR,
    payload,
  };
};
